import { render, staticRenderFns } from "./BaseSearchableSelector.vue?vue&type=template&id=5c128464"
import script from "./BaseSearchableSelector.vue?vue&type=script&lang=js"
export * from "./BaseSearchableSelector.vue?vue&type=script&lang=js"
import style0 from "./BaseSearchableSelector.vue?vue&type=style&index=0&id=5c128464&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports